export default {
    getYearMonthDate(time) {
        return "2024-01-01"
    },
    getDate(time) {
        return "11"
    },
    getYearMonth(time) {
        return "2024年05月"
    },
    getYearMonth2(time) {
        return "2024-05"
    },
    getTime(time) {
        return "13:58:30"
    },
}